var _this = this;
import axios from 'axios';
import store from "../store";
import { getToken, setToken } from '@/utils/auth';
import i18n from "../lang"; // Internationalization
import { Message } from 'element-ui';

// create an axios instance
var service = axios.create({
  timeout: 50000,
  // request timeout
  maxContentLength: 200000
});

// request interceptor
service.interceptors.request.use(function (config) {
  if (store.getters.token) {
    config.headers.Authorization = "Bearer ".concat(getToken());
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// respone interceptor
service.interceptors.response.use(function (response) {
  setToken(getToken());
  if (response.status === 201) {
    var location = response.headers.location;
    if (location && response.data === '') {
      response.data = {
        id: location.substr(location.lastIndexOf('/') + 1)
      };
    }
  }
  return response;
}, function (error) {
  var errorMessage = error.message;
  if (error.response.data.status >= 400 || error.response.status >= 400 || error.message !== undefined) {
    // eslint-disable-next-line
    if (error.response.status === 429) {
      errorMessage = i18n.t('errors.tooManyRequests');
      Message.error(errorMessage);
    }
  }
  if (error.message !== undefined && error.message === 'Request failed with status code 500') {
    errorMessage = i18n.t('errors.500');
  } else if (error.response.data.status === 400) {
    // error.reponse.data.validations = error.response.data.errors.DomainValidations;
  } else if (error.message !== undefined && error.message === 'Request failed with status code 401') {
    return _this.$router.push({
      path: '/login'
    });
  } else if (error.message !== undefined && error.message === 'Network Error') {
    errorMessage = i18n.t('errors.networkerror'); // 'Giriş esnasında bir hata oluştu.(101)';
  } else {
    errorMessage = i18n.t('errors.unknownloginerror');
  }
  error.message = errorMessage;
  return Promise.reject(error);
});
export default (function (method, resource, data, baseUrl) {
  var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  return service({
    method: method,
    url: resource,
    data: data,
    baseURL: baseUrl === undefined ? process.env.VUE_APP_BASE_API : baseUrl,
    config: config
  });
});